// Urgency bucketing for the Tasks page (04-tasks): Overdue · Today ·
// Tomorrow · This week (rolling 7 days) · Later · No due date.
// Pure string comparison over YYYY-MM-DD — the caller supplies "today" from
// melbourneToday() so business dates stay Australia/Melbourne.

export const TASK_BUCKETS = ['overdue', 'today', 'tomorrow', 'week', 'later', 'none'] as const;
export type TaskBucket = (typeof TASK_BUCKETS)[number];

export const BUCKET_LABELS: Record<TaskBucket, string> = {
  overdue: 'Overdue',
  today: 'Today',
  tomorrow: 'Tomorrow',
  week: 'This week',
  later: 'Later',
  none: 'No due date',
};

/** ISO date n days after the given ISO date (calendar-safe). */
export function addDaysIso(iso: string, days: number): string {
  const d = new Date(`${iso}T00:00:00`);
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function bucketFor(due: string | null, today: string): TaskBucket {
  if (!due) return 'none';
  if (due < today) return 'overdue';
  if (due === today) return 'today';
  if (due === addDaysIso(today, 1)) return 'tomorrow';
  if (due <= addDaysIso(today, 7)) return 'week';
  return 'later';
}
